module.exports = __webpack_public_path__ + "static/media/yellow-template-small.c5775f47.png";